export default function FinalCTA() {
  return (
    <section className="py-20 md:py-32 bg-[#0F1B2E] relative overflow-hidden">
      {/* Background Radial Gradient */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-radial from-[#D4AF37]/10 via-transparent to-transparent"></div>
      </div>

      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-[#D4AF37]/5 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-[#D4AF37]/5 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 md:px-8 lg:px-16 text-center">
        {/* Top Line */}
        <div className="w-28 h-1 bg-[#D4AF37] mx-auto mb-10"></div>

        {/* Heading */}
        <h2 className="text-2xl md:text-4xl lg:text-5xl xl:text-6xl font-black text-white leading-tight mb-8 font-serif">
          表面的な眺めの話ではなく<br />
          「なぜ成立しているのか」という構造をすべて話します。
        </h2>

        {/* Content */}
        <div className="max-w-3xl mx-auto mb-12">
          <p className="text-lg md:text-xl text-gray-300 leading-relaxed">
            任意でもご興味をお持ちの方は、まずはWEBセミナーにご参加ください。
          </p>
        </div>

        {/* CTA Button with Pulse Animation */}
        <div className="relative inline-block mb-16 w-full md:w-auto max-w-[85%] md:max-w-none mx-auto">
          {/* Outer Pulse Ring */}
          <div className="absolute inset-0 animate-ping opacity-75">
            <div className="w-full h-full border-4 border-[#D4AF37] rounded-full"></div>
          </div>

          {/* Middle Pulse Ring */}
          <div className="absolute inset-0 animate-pulse">
            <div className="w-full h-full bg-[#D4AF37]/20 rounded-full"></div>
          </div>

          <a 
            href="https://forms.gle/vdJZoFV3tEuxApQD7"
            target="_blank"
            rel="noopener noreferrer"
            className="relative group bg-gradient-to-r from-[#D4AF37] to-[#F4C542] text-[#0A1628] font-black text-xs md:text-xl px-4 md:px-16 py-3 md:py-7 rounded-full inline-flex items-center gap-2 md:gap-4 hover:shadow-2xl hover:shadow-[#D4AF37]/60 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer w-full md:w-auto justify-center"
          >
            【無料WEBセミナーに申し込む】
            <div className="w-7 h-7 md:w-12 md:h-12 flex items-center justify-center bg-white rounded-full group-hover:translate-x-2 transition-transform duration-300 flex-shrink-0">
              <i className="ri-arrow-right-line text-[#0A1628] text-base md:text-2xl"></i>
            </div>
          </a>
        </div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="bg-white/5 backdrop-blur-sm p-6 rounded-xl border border-white/10">
            <i className="ri-time-line text-[#D4AF37] text-4xl mb-3"></i>
            <div className="text-white font-bold mb-2">所要時間</div>
            <div className="text-gray-300 text-sm">約90分</div>
          </div>
          <div className="bg-white/5 backdrop-blur-sm p-6 rounded-xl border border-white/10">
            <i className="ri-money-dollar-circle-line text-[#D4AF37] text-4xl mb-3"></i>
            <div className="text-white font-bold mb-2">参加費用</div>
            <div className="text-gray-300 text-sm">完全無料</div>
          </div>
          <div className="bg-white/5 backdrop-blur-sm p-6 rounded-xl border border-white/10">
            <i className="ri-computer-line text-[#D4AF37] text-4xl mb-3"></i>
            <div className="text-white font-bold mb-2">参加方法</div>
            <div className="text-gray-300 text-sm">オンライン(Zoom)</div>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="mt-16 pt-12 border-t border-white/10">
          <div className="flex flex-wrap justify-center items-center gap-8 text-gray-400 text-sm">
            <div className="flex items-center gap-2">
              <i className="ri-shield-check-line text-[#D4AF37] text-xl"></i>
              <span>個人情報保護</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-lock-line text-[#D4AF37] text-xl"></i>
              <span>SSL暗号化通信</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-customer-service-2-line text-[#D4AF37] text-xl"></i>
              <span>無料相談対応</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
